import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import swal from 'sweetalert'
import Services from '../services/Services'

function Partner(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const history = useHistory()
  const services = new Services(this)
  const dispatch = useDispatch()

  //const authResponse = useSelector(state=>state.userAuth.authResponse);

  const [fields, setFields] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
  })

  const handleFieldChange = (e) => {
    setFields({
      ...fields,
      [e.target.id]: e.target.value,
    })
  }

  const partnerRegister = (e) => {
    e.preventDefault()
    services.signupPartner(fields).then((resp) => {
      setFields({
        name: '',
        phone: '',
        email: '',
        city: '',
      })
      swal({
        title: 'Success!',
        text: 'Partner Created!',
        icon: 'success',
        timer: 1500,
      })
    })
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner form-page"
          style={{ backgroundImage: `url('images/partner-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <video
                  style={{ width: '100%', marginTop: 120 }}
                  autoPlay
                  controls
                  muted
                >
                  <source src="/partner.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div
                  className="partner-banner-content"
                  style={{ textAlign: 'right', paddingTop: 50 }}
                >
                  <h1>
                    Scale your
                    <br /> business with us!
                  </h1>
                  <text>
                    Grow your business with the additional earnings you’ll get
                    when joining the RoadJockey family. Our new app platform is
                    an excellent way to market your restaurant, grocer, and
                    convenience store to everyone around Jamaica.{' '}
                  </text>
                </div>
                <div className="mt-5 mb-5" style={{ textAlign: 'right' }}>
                  <Link
                    to="#"
                    data-toggle="modal"
                    data-target="#exampleModal11"
                  >
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="benefit-sec yellow-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/partner_page/partner.jpg"
                    width="716.66"
                    height="452.06"
                    alt="Monitor Your Orders"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="benefit-content">
                  <h2>Increase Your Sales</h2>
                  <br />
                  <label>
                    We bring the clients to you. Your sales will grow as more
                    and more eyes scroll through your menu and food items.
                    Imagine being able to market your business 24/7 without
                    doing anything more than posting a few photos and filling in
                    some basic information. Our goal is to empower your
                    business.
                  </label>
                </div>
                <div className="mt-5 mb-3">
                  <Link
                    to="#"
                    data-toggle="modal"
                    data-target="#exampleModal11"
                  >
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-5">
                <div className="benefit-content">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <h2>Easily Track Your Successes</h2>
                  <label>
                    <br />
                    The RoadJockey app allows all our Food Partners to easily
                    track each Roadie for delivery as well as your recent sales.
                    You’ll gain valuable insight into what people like the most,
                    how well your photo marketing is performing, and what
                    locations seek your business.
                  </label>
                </div>
                <div className="mt-5 mb-3">
                  <Link
                    to="#"
                    data-toggle="modal"
                    data-target="#exampleModal11"
                  >
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/about_us/about.jpg"
                    width="716.66"
                    height="452.06"
                    alt="Grow Your Brand"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="benefit-sec lgreen-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/others/restaurants-clients.jpg"
                    width="716.66"
                    height="452.06"
                    alt="Improve Sales"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="benefit-content">
                  <h2>Stronger Customer Relationships</h2>
                  <br />
                  <label>
                    RoadJockey offers you the opportunity to get your know your
                    customers on a more intimate level. Now you can adjust your
                    menu to fit the needs and values of the clients that request
                    you the most. This partnership will only grow your future
                    success.
                  </label>
                </div>
                <div className="mt-5 mb-3">
                  <Link
                    to="#"
                    data-toggle="modal"
                    data-target="#exampleModal11"
                  >
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-5">
                <div className="benefit-content">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <h2>The Beauty of Jamaica</h2>
                  <br />
                  <label>
                    Our app is designed by Jamaicans who understand all the
                    islands have to offer. We work closely with each of our Food
                    Partners to ensure each question receives a quality answer.
                    You have all the support you need to improve the overall
                    economy and increasing your reputation. The more we help
                    you, the better we all do.
                  </label>
                </div>
                <div className="mt-5 mb-3">
                  <Link
                    to="#"
                    data-toggle="modal"
                    data-target="#exampleModal11"
                  >
                    <button className="primary-btn">Join Us</button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="benfit-figure">
                  <img
                    src="images/riders_page/client-rider.jpg"
                    width="716.66"
                    height="452.06"
                    alt="Deliver order"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className="modal fade"
          id="exampleModal11"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="partner-form">
                <div className="heading-text border-bottom">
                  <h3>Partner with us</h3>
                  <p>
                    We need more information about your business to assess the
                    partnership possibilities
                  </p>
                </div>
                <form onSubmit={partnerRegister}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name      "
                          placeholder="Restaurant Name*"
                          id="name"
                          value={fields.name}
                          onChange={handleFieldChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          placeholder="Email"
                          type="email"
                          name="email"
                          id="email"
                          value={fields.email}
                          onChange={handleFieldChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Phone Number"
                          name="phone"
                          id="phone"
                          value={fields.phone}
                          onChange={handleFieldChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          name="city"
                          id="city"
                          value={fields.city}
                          onChange={handleFieldChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <p>
                        By clicking ‘Submit’, you agree to{' '}
                        <Link to="/termsandconditions">
                          Road Jockey General Terms and Conditions
                        </Link>{' '}
                        and acknowledge that you have read the{' '}
                        <Link to="/privacypolicy">Privacy Policy.</Link>
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <button className="primary-btn" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* <div className="modal-body">
                  <div className="size">
                      <p>
                      We need more information about your business to assess the
                      partnership possibilities
                    </p>
                    

                  </div>
                </div> */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="secondary-btn"
                  data-dismiss="modal"
                >
                  Back
                </button>
                {/* {clocation !== "" ? (
                    <a href="/restaurants">
                      <button type="button" className="primary-btn">
                        Select
                      </button>
                    </a>
                  ) : (
                    ""
                  )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Partner
